import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    actionContainer: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center",
        flexWrap: "wrap"
    },
    formContainer: {
        justifyContent: "space-between",
        alignItems: "flex-end",
        flexDirection: "row",
        flexWrap: "wrap"
    },
    buttonWrapper: {
        justifyContent: "flex-end"
    },
    loadingContainer: {
        justifyContent: "center",
        alignItems: "center",
        flex: 1
    },
    errorContainer: {
        justifyContent: "center",
        alignItems: "center",
        flex: 1
    },
    stateCardContainer: {
        justifyContent: "center",
        alignItems: "center",
        flex: 1
    },
    bottomActionContainer: {
        justifyContent: "center",
        flexDirection: "row",
        alignItems: "center",
        flexWrap: "wrap"
    },
    navigationButton: {
        justifyContent: "center",
        minWidth: 130
    },
    fullWidthButtonWrapper: {
        width: "100%"
    },
    contentContainer: {
        flexDirection: "row",
        flexWrap: "wrap"
    },
    tablesContainer: {
        flexDirection: "row",
        flexWrap: "wrap",
        flex: 1
    },
    roundInfoContainer: {
        alignItems: "center",
        flexDirection: "row",
        flexWrap: "wrap"
    },
    roundActionContainer: {
        flexDirection: "row",
        flexWrap: "wrap"
    },
    pastEventsContainer: {
        flexDirection: "row",
        flexWrap: "wrap"
    },
    inputContainer: {
        width: 200
    },
    tableWrapper: {
        width: 300
    }
});

export default stylesheet;
